import {
  FETCH_TOKEN_REJECTED,
  FETCH_TOKEN_FULFILLED
} from "../constants/signin";

const initialState = {
  pending: true,
  customer: {},
  error: {},
  redirect: false
};

export const signin = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TOKEN_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error
      };

    case FETCH_TOKEN_FULFILLED:
      return {
        ...state,
        pending: false,
        redirect: true,
        error: {}
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/signin.js